// extracted by mini-css-extract-plugin
export default {"crownIcon":"lrtsgsOy_qece6TJvKwZ"};